import ApiService from './ApiService';

export default class UserApi extends ApiService {
    getUsers(payload) {
        return this.get('users', payload);
    }
}
